import Vue from 'vue';
import VueGtm from 'vue-gtm';
import VueRouter from "vue-router";
import VueLazyload from 'vue-lazyload'
import router from './router'
import App from './App.vue';


Vue.use(VueRouter)
Vue.use(VueLazyload, {
  observer: true,
  attempt: 50
})

Vue.use(VueGtm, {
  enabled: true,
  debug: false,
  vueRouter: router,
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')